<template>
  <div>
    <PlusButton intent="link" @click="displayCropImageDialog">{{label ?? "Upload Image"}}</PlusButton>
    <v-dialog v-model="cropImageDialog" max-width="80%">
      <v-card style="overflow-x:hidden" outlined>
        <v-card-text class="text-center">
          <div class="text-subtitle-1" v-if="!showCroppie">{{ $t('message.select_image_crop') }}</div>
          <div class="text-caption" style="color:red">{{ toBigMessage }}</div>
        </v-card-text>
        <v-card-text>
          <vue-croppie v-if="showCroppie" ref="croppie" :enable-exif="true" :enableOrientation="true" @result="result"
            :viewport="croppieViewport" :boundary="croppieViewportBoundary" :enable-resize="resize"
            :show-zoomer="false">
          </vue-croppie>
          <input style="display:none" type="file" @change="readFile" ref="fileUploadInput" />
        </v-card-text>
        <div v-if="uploading" class="mb-1">
          <v-progress-linear buffer-value="5" color="success" height="15" stream :value="uploadPercentage">
          </v-progress-linear>
        </div>
        <v-card-actions v-if="!isSmallerDisplay()">
          <v-btn outlined elevation="0" small @click="openFileUploader()" color="primary">
            <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
            <span>{{ $t("message.pick_image") }}</span>
          </v-btn>
          <v-btn elevation="0" small @click="rotate(90)" :disabled="disableConfirm">
            <v-icon>mdi-format-rotate-90</v-icon>
            <span>{{ $t("message.rotate") }}</span>
          </v-btn>
          <span v-if="uploading">uploading...</span>
          <v-spacer></v-spacer>
          <v-btn elevation="0" small @click="processImage()" color="success" :disabled="disableConfirm">
            <v-icon>mdi-check-circle-outline</v-icon>
            <span>{{ $t("message.confirm") }}</span>
          </v-btn>
          <v-btn elevation="0" small @click="closeDialog()">
            <span>{{ $t("message.close") }}</span>
          </v-btn>
        </v-card-actions>
        <v-card-text v-else>
          <v-btn outlined block class="mt-1" elevation="0" small @click="openFileUploader()" color="primary">
            <v-icon>mdi-plus-circle-outline</v-icon>
            <span>{{ $t("message.pick_image") }}</span>
          </v-btn>
          <v-btn block class="mt-1" elevation="0" small @click="rotate(90)" :disabled="disableConfirm">
            <v-icon>mdi-format-rotate-90</v-icon>
            <span>{{ $t("message.rotate") }}</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn block class="mt-1" elevation="0" small @click="processImage()" color="success"
            :disabled="disableConfirm">
            <v-icon>mdi-check-circle-outline</v-icon>
            <span>{{ $t("message.confirm") }}</span>
          </v-btn>
          <v-btn block class="mt-1" elevation="0" small @click="closeDialog()">
            <span>{{ $t("message.close") }}</span>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";

import {
} from '@vue-hero-icons/outline'
import PlusButton from "@/components/plus/PlusButton";

export default {
  components: {
    PlusButton
  },
  data() {
    return {
      image: null,
      cropped: null,
      uploadPercentage: 0,
      cropImageDialog: false,
      disableConfirm: true,
      uploadingMessage: null,
      resize: false,
      callWhenDone: null,
      buttonColor: 'primary',
      uploading: false,
      showCroppie: false,
      toBigMessage: null,
      croppieViewport: { width: 200, height: 200, type: 'square' },
      croppieViewportBoundary: { width: 250, height: 250 }
    };
  },
  props: ["successFunction", "vm", "enableResize", "addSmall", "fab", "color", "label", "block"],
  watch: {},
  created() {
    this.callWhenDone = this.successFunction;
    if (this.enableResize)
      this.resize = this.enableResize;
    this.getCroppieViewport();
    if (this.color)
      this.buttonColor = this.color;
  },
  methods: {
    getCroppieViewport() {
      if (this.$vuetify.breakpoint.name == 'xs' ||
        this.$vuetify.breakpoint.name == 'sm') {
        this.croppieViewport = { width: 200, height: 200, type: 'square' };
        this.croppieViewport = { width: 250, height: 250 };
      }
    },
    closeDialog() {
      this.cropImageDialog = false;
      this.clearCroppie();
    },
    clearCroppie() {
      this.image = null;
      this.cropped = null;
      this.disableConfirm = true;
      this.uploading = false;
      this.showCroppie = false;
      this.$refs.fileUploadInput.value = null;
      if (this.$refs.croppie)
        this.$refs.croppie.destroy();
    },
    openFileUploader() {
      this.$refs.fileUploadInput.click();
    },
    readFile(event) {
      var vm = this;
      this.toBigMessage = null;
      this.showCroppie = true;
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          vm.$refs.croppie.bind({
            url: e.target.result
          });
        };
        reader.readAsDataURL(event.target.files[0]);
      }
      this.disableConfirm = false;
    },
    processImage() {
      this.uploading = true;
      this.disableConfirm = true;
      let options = {
        format: "jpeg",
        size: { width: 1000 },
        circle: false,
        quality: 1
      };
      const vm = this;
      this.$refs.croppie.result(options, output => {
        vm.cropped = output;
        setTimeout(function () {
          vm.uploadImage(output);
        }, 4000);
      });
    },
    displayCropImageDialog() {
      this.cropImageDialog = !this.cropImageDialog;
    },
    bind() {
      if (!this.image)
        this.image = '';
      if (this.$refs.croppie) {
        this.$refs.croppie.bind({
          url: this.image
        });
      }
    },
    cropViaEvent() {
      this.$refs.croppie.result();
    },
    result(output) {
      this.cropped = output;
    },
    uploadImage(ImageURL) {
      // Split the base64 string in data and contentType
      var block = ImageURL.split(";");
      // Get the content type
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "iVBORw0KGg...."

      // Convert to blob
      var blob = this.b64toBlob(realData, contentType);

      // Create a FormData and append the file
      //var fd = new FormData();
      //fd.append('filename','afilename.jpg');
      //fd.append("image", blob);

      //PUSH
      try {
        const vm = this;
        const d = new Date();
        const formData = new FormData();

        this.uploadingMessage = this.$t('message.image_upload_progress');
        const millis = d.getTime();
        formData.append("image", blob, 'bjjlink-user-cropped-admin-uploaded-image-' + millis + '.' + contentType);
        Api().post("content/img/cropped", formData, {//Cropped always creates a small version
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            const percent = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
            if (percent >= 97)
              vm.uploadPercentage = 97;//Stay on 97
            else
              vm.uploadPercentage = percent;
          },
        })
          .then(res => {
            if (res) {
              setTimeout(function () {
                //vm.callWhenDone(res.data.location, vm.vm, res.data.smallImageLocation);
                vm.callWhenDone(res.data, vm.vm);
                //this.callWhenDone(res.data.location, this.vm);
                vm.closeDialog();
                vm.uploading = false;
              }, 4000);
            }
          })
          .catch(err => {
            this.uploadingImage = false;
            if (err)
              this.showAlert('error', this.$t('message.oops_not_working'));
          });
      } catch (err) {
        console.log('WTF?????', err);
        this.showAlert('error', this.$t('message.oops_not_working'));
      }
    },
    rotate(rotationAngle) {
      this.$refs.croppie.rotate(rotationAngle);
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }
  }
};
</script>

<style scoped></style>
